import React from "react";

function ErrorMessage() {
  return <div>Nessun cocktail trovato</div>;
}

export default ErrorMessage;
